import { useQuery } from '@apollo/client';
import { getFiles, getFileById } from '../application/query';
function checkShouldSkip(id) {
  return !id || Array.isArray(id) && !id.length;
}
const getWhereQuery = id => {
  const inClause = Array.isArray(id) ? id : [id];
  return {
    where: {
      id: {
        _in: inClause
      }
    }
  };
};
const useGetImages = (id, hasMultipleIds = false, skip = false) => {
  const shouldSkip = skip || checkShouldSkip(id);
  const variables = hasMultipleIds ? getWhereQuery(id) : {
    id
  };
  const currentQuery = hasMultipleIds ? getFiles : getFileById;
  const {
    data = {},
    loading,
    error
  } = useQuery(currentQuery, {
    variables,
    skip: shouldSkip
  });
  return {
    data,
    loading,
    error
  };
};
export default useGetImages;
//# sourceMappingURL=use-get-images.js.map